import { createFileRoute } from '@tanstack/react-router';

import { QaPortalAccessGate } from '@/features/qa/qa-portal/qa-portal-access-gate';

export const Route = createFileRoute('/qa')({
  component: QaPortalAccessGate,
});
